import React from "react";
import { Chip } from "@mui/material";

const flow = {
  results: { label: "Results", color: "green" },
  waiting: { label: "Pending", color: "yellow" },
  no_results: { label: "No Results", color: "grey" },
};

export const WorkOrderTestStatusChip = ({ item }) => {
  const final = item?.hasResults ? flow.results : flow.no_results;

  return (
    <Chip
      label={final.label}
      variant="colorTag"
      flow={final.color}
      sx={{
        my: "-5px",
        "& .MuiChip-label": {
          fontSize: 10,
          fontWeight: 600,
        },
      }}
    />
  );
};

export default WorkOrderTestStatusChip;
